import { keccak256 } from "viem";
import { encodeDepositTx } from "./encodeDepositTx";
export const computeFacetTransactionHash = (l1TransactionHash, from, to, value, data, gasLimit, mint) => {
    const encodedTx = encodeDepositTx({
        sourceHash: l1TransactionHash,
        from,
        to,
        mint,
        value,
        gasLimit,
        data,
    });
    return keccak256(encodedTx);
};
